import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentAboutDto extends EpimsBaseEntityDto {
  
  AboutName: string;
  AboutDescription: string;
  SubscriptionUserId: string;  
  Version: number;
}
